module.exports = __webpack_public_path__ + "static/media/akdammCup.64e45964.jpg";